module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Airpods-afc6028874a81c870755e33426df6285.svg";